import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useLocation } from '../../hooks/useLocation.js';
import { OfficesAtmsMapLayout } from './OfficesAtmsMapLayout.js';
import { getAtmPoint, renderAtmCard } from './renderAtmCard.js';
import { useAtms } from './useAtms.js';
const INITIAL_FILTRATION_STATE = {
    terminalTypeAtms: true,
    terminalTypeTerm: false,
    workAllTime: false,
    billAcceptorEnable: false,
    locationDisabledPeople: false,
    designDisabledPeople: false,
};
const FILTRATION_PREDICATES = {
    terminalTypeAtms: (item) => item.terminalType?.toLowerCase() === 'банкомат',
    terminalTypeTerm: (item) => item.terminalType?.toLowerCase() === 'терминал',
    workAllTime: (item) => item.workTime?.toLowerCase() === 'круглосуточно',
    billAcceptorEnable: (item) => Boolean(item.billAcceptorEnable),
    locationDisabledPeople: (item) => Boolean(item.locationDisabledPeople),
    designDisabledPeople: (item) => Boolean(item.designDisabledPeople),
};
export const AtmsMap = JSX(({ descriptionData, className }) => {
    const [currentLocation] = useLocation();
    const regionCode = currentLocation?.code ?? '000';
    const { data: officesData, isLoad } = useAtms(regionCode);
    return (_jsx(OfficesAtmsMapLayout, { className: className, filterItems: filterItems, data: officesData, isLoad: isLoad, initFilterState: INITIAL_FILTRATION_STATE, renderCard: renderAtmCard, getBalloon: getAtmPoint, title: `Банкоматы филиала ${currentLocation?.name}`, descriptionData: descriptionData }));
});
const filterItems = (data, filtrationState) => {
    const truthyFilters = Object.keys(filtrationState).filter((key) => filtrationState[key]);
    const filtersOR = truthyFilters.filter((_) => _.startsWith('terminalType'));
    const filtersAND = truthyFilters.filter((_) => !filtersOR.includes(_));
    return data.filter((item) => {
        const resultAND = filtersAND.every((_) => FILTRATION_PREDICATES[_](item));
        const resultOR = filtersOR.length
            ? filtersOR.some((_) => FILTRATION_PREDICATES[_](item))
            : true;
        return resultAND && resultOR;
    });
};
//# sourceMappingURL=AtmsMap.js.map